import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faHistory } from "@fortawesome/free-solid-svg-icons";
import { displayHistory } from "../Utils/DocsManager";

const Token = Cookies.get("Token");
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const renderDataCellDocsAdm = (item, col, context, idx) => {
  const value = getNestedValue(item, col.key);

  switch (col.admData) {
    case "Admin actions":
      return (
        <td key={`actions-${idx}`}>
          <button
            title={context.t("Relaunch document")}
            className="btn ActionsButton"
            onClick={() => context.handleRelaunchClick(item)}
          >
            <FontAwesomeIcon icon={faRotate} style={{ marginRight: "5px" }} />
          </button>
          <button
                      title={context.t("view history")}
                      className="btn ActionsButton"
                      onClick={() => {
                        displayHistory(item.DocId, item.History)
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHistory}
                        style={{ marginRight: "5px" }}
                        className="fa-copy"
                      />
                    </button>
        </td>
      );
    default:
      return (
        <td
          key={`default-${idx}`}
          style={{
            fontWeight: col.bold ? "bold" : "normal",
            width: "100px",
            fontSize: "14px",
          }}
        >
          {value}
        </td>
      );
  }
};
